module.exports = __webpack_public_path__ + "static/media/700d77aa-2d03-4799-a1c0-0b6be7066998_1.7e0efa401843167393ee000659f70949.0797800c.jpeg";